<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import { DropdownOption } from '@/types/inputs'

import MyRadioButton from '@/components/my-components/form/MyRadioButton.vue'
import MyRadioButtonGroup from '@/components/my-components/form/MyRadioButtonGroup.vue'

const weekday = defineModel<number>({ required: true })

export interface Props {
    small?: boolean
}

const props = defineProps<Props>()

const { t } = useI18n()

const weekdays = computed<DropdownOption<number>[]>(() => {
    return [
        { value: 0, label: t('monday') },
        { value: 1, label: t('tuesday') },
        { value: 2, label: t('wednesday') },
        { value: 3, label: t('thursday') },
        { value: 4, label: t('friday') },
        { value: 5, label: t('saturday') },
        { value: 6, label: t('sunday') },
    ]
})
</script>

<template>
    <MyRadioButtonGroup v-model="weekday" :label="t('weekday')">
        <MyRadioButton
            v-for="day in weekdays"
            :key="day.value"
            :value="day.value"
            :label="day.label"
            :small="props.small"
        />
    </MyRadioButtonGroup>
</template>
